import { ScrollText } from "lucide-react";
import { SectionCard } from "@/components/report/SectionCard";
import { fmtSqft, fmtMoney, fmtInt } from "@/lib/permitcheck";
import { useLang } from "@/lib/i18n";

const Cell = ({ label, value, mono, na, naText, testid }) => (
  <div data-testid={testid} className="rounded-lg border border-border bg-secondary/40 px-3 py-2.5">
    <p className="font-mono text-[9px] uppercase tracking-wider text-muted-foreground">{label}</p>
    <p className={`mt-0.5 text-sm font-semibold text-foreground ${mono ? "font-mono" : ""}`}>
      {na ? <span className="text-xs font-normal text-muted-foreground">{naText}</span> : value}
    </p>
  </div>
);

export const RecordsSection = ({ report, lang }) => {
  const { t } = useLang();
  const r = report.property_records || {};
  const src = (report.sources || []).find((s) => s.field === "property_records" || (s.service || "").includes("Property"));

  const bldg = r.building_area ? `${fmtInt(r.building_area, lang)} ${lang === "es" ? "pies²" : "sq ft"}` : "—";

  return (
    <SectionCard
      icon={ScrollText}
      title={t("sec.records")}
      source={src}
      retrievedAt={report.retrieved_at}
      lang={lang}
      testid="section-records"
    >
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        <Cell label={t("rec.owner")} value={r.owner || "—"} testid="rec-owner" />
        <Cell label={t("rec.use")} value={r.property_use || "—"} testid="rec-use" />
        <Cell label={t("rec.landUse")} value={r.land_use || "—"} testid="rec-land-use" />
        <Cell label={t("rec.lot")} value={fmtSqft(r.lot_size, lang)} mono testid="rec-lot" />
        <Cell label={t("rec.building")} value={bldg} mono testid="rec-building" />
        <Cell label={t("rec.year")} value={r.year_built || "—"} mono testid="rec-year" />
        <Cell label={t("rec.assessed")} value={fmtMoney(r.assessed_value, lang)} mono testid="rec-assessed" />
        <Cell label={t("rec.landValue")} value={fmtMoney(r.land_value, lang)} mono />
        <Cell label={t("rec.buildingValue")} value={fmtMoney(r.building_value, lang)} mono />
        <Cell label={t("rec.beds")} value={r.bedrooms ?? "—"} mono />
        <Cell label={t("rec.baths")} value={r.bathrooms ?? "—"} mono />
        <Cell label={t("rec.units")} value={r.units ?? "—"} mono />
        <Cell label={t("rec.buildings")} value={r.buildings ?? "—"} mono />
        <Cell label={t("rec.subdivision")} value={r.subdivision || "—"} mono />
        <Cell label={t("rec.legal")} na={!r.legal_description} naText={t("rec.na")} value={r.legal_description} />
      </div>
    </SectionCard>
  );
};
